import React from 'react';
import { Trophy } from 'lucide-react';

interface WeeklyChallengeProps {
  challenge: {
    id: number;
    title: string;
    description: string;
    reward: number;
    progress: number;
    total: number;
    message: string;
  };
}

export function WeeklyChallenge({ challenge }: WeeklyChallengeProps) {
  const progress = (challenge.progress / challenge.total) * 100;

  return (
    <div className="theme-card p-4 space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Trophy className="w-5 h-5 text-warning" />
          <h3 className="font-medium">{challenge.title}</h3>
        </div>
        <div className="text-sm text-primary">
          {challenge.reward} pts
        </div>
      </div>
      
      <p className="text-sm text-muted-foreground">{challenge.description}</p>
      
      <div>
        <div className="flex items-center justify-between text-sm mb-2">
          <span className="text-muted-foreground">Progress</span>
          <span>{Math.round(progress)}%</span>
        </div>
        <div className="theme-progress-bar h-2">
          <div 
            className="theme-progress-bar-value"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      <div className="text-sm text-primary/80">
        {challenge.message}
      </div>
    </div>
  );
}